package vegasful.admin

/**
 * Convert a string to a simple slug. Doesn't handle all cases, just basics.
 */
fun String?.simpleSlug(): String {
    if (this.isNullOrBlank()) return ""
    return lowercase().replace(Regex("[^a-zA-Z0-9-]"), "-")
        .replace(Regex("[-][-]+"), "-") // replace multiple dashes with a single
}